export const IBR_LIST_FILTER_STORAGE_KEY = "ibr-list-sticky-filters";
export const STUDENT_SHARED_FILTER_STORAGE_KEY = "student-shared-filters";

export const STUDENT_SHARED_QUERY_KEYS = [
  "date_range",
  "utm_source",
  "school_type",
  "school",
  "industry",
  "industry_name",
  "loan_type",
  "borrower_type",
  "initiated_by",
  "servicer",
  "lender_bank",
];

export const IBR_ONLY_QUERY_KEYS = ["admin_action", "stage_status", "search"];

export const IBR_LIST_STICKY_QUERY_KEYS = [
  ...STUDENT_SHARED_QUERY_KEYS,
  ...IBR_ONLY_QUERY_KEYS,
];

export const IBR_LIST_DRAWER_QUERY_KEYS = [
  "date_range",
  "utm_source",
  "school_type",
  "school",
  "industry",
  "industry_name",
  "loan_type",
  "borrower_type",
  "initiated_by",
  "servicer",
  "lender_bank",
  "from_date",
  "end_date",
];

const hasFilterValue = (value) => {
  if (value === undefined || value === null || value === "") return false;
  if (Array.isArray(value) && value.length === 0) return false;
  return true;
};

const pickQueryKeys = (keys, query = {}) =>
  keys.reduce((acc, key) => {
    if (hasFilterValue(query[key])) {
      acc[key] = query[key];
    }
    return acc;
  }, {});

export const pickSharedQuery = (query = {}) =>
  pickQueryKeys(STUDENT_SHARED_QUERY_KEYS, query);

export const pickIbrOnlyQuery = (query = {}) =>
  pickQueryKeys(IBR_ONLY_QUERY_KEYS, query);

export const pickStickyQuery = (query = {}) =>
  pickQueryKeys(IBR_LIST_STICKY_QUERY_KEYS, query);

export const readStickyFilters = () => {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(IBR_LIST_FILTER_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const sticky = pickStickyQuery(parsed);
    return Object.keys(sticky).length > 0 ? sticky : null;
  } catch (error) {
    return null;
  }
};

export const writeStickyFilters = (query = {}) => {
  if (typeof window === "undefined") return;
  const sticky = pickStickyQuery(query);
  if (Object.keys(sticky).length === 0) {
    sessionStorage.removeItem(IBR_LIST_FILTER_STORAGE_KEY);
    return;
  }
  sessionStorage.setItem(IBR_LIST_FILTER_STORAGE_KEY, JSON.stringify(sticky));
};

export const readSharedFilters = () => {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(STUDENT_SHARED_FILTER_STORAGE_KEY);
    if (!raw) return null;
    const sticky = pickSharedQuery(JSON.parse(raw));
    return Object.keys(sticky).length > 0 ? sticky : null;
  } catch (error) {
    return null;
  }
};

export const writeSharedFilters = (query = {}) => {
  if (typeof window === "undefined") return;
  const shared = pickSharedQuery(query);
  if (Object.keys(shared).length === 0) {
    sessionStorage.removeItem(STUDENT_SHARED_FILTER_STORAGE_KEY);
    return;
  }
  sessionStorage.setItem(
    STUDENT_SHARED_FILTER_STORAGE_KEY,
    JSON.stringify(shared),
  );
};

export const syncSharedFilters = (query = {}) => {
  const shared = pickSharedQuery(query);
  writeSharedFilters(shared);
  const existing = readStickyFilters() || {};
  const ibrOnly = {
    ...pickIbrOnlyQuery(existing),
    ...pickIbrOnlyQuery(query),
  };
  writeStickyFilters({ ...ibrOnly, ...shared });
};

export const clearSharedFilters = () => {
  syncSharedFilters({});
};

export const stageBarsToQuery = (bars = []) =>
  bars
    .filter((item) => item?.stage && item?.status?.length)
    .map((item) => `${item.stage}:${item.status.join(",")}`)
    .join(";");

export const stageQueryToBars = (value) => {
  if (!value) return [];
  const raw = Array.isArray(value) ? value.join(";") : String(value);
  return raw
    .split(";")
    .filter(Boolean)
    .map((part) => {
      const [stage, statusString = ""] = part.split(":");
      return {
        stage,
        status: statusString.split(",").filter(Boolean),
      };
    })
    .filter((item) => item.stage && item.status.length > 0);
};
